const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT}/api/v1`;
const GATE_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/gate";

export default {

    GET_GATE_LIST:                            GATE_API_ENDPOINT + "/list",
    CREATE_GATE:                              GATE_API_ENDPOINT + "/create",
    VIEW_GATE:                                GATE_API_ENDPOINT + "/view",
    UPDATE_GATE_STATUS:                       GATE_API_ENDPOINT + "/update/status",
    DELETE_GATE:                              GATE_API_ENDPOINT + "/delete",
    FILTER_GATE:                              GATE_API_ENDPOINT + "/filter/list",
}
